import React from 'react';
import PropTypes from 'prop-types';
import leftPad from 'left-pad';
import TextField from 'material-ui/TextField';

import styles from './styles/BankAccount';

// https://v0.material-ui.com/v0.20.0/#/components/text-field
const TField = ({
  input, label, customStyle, meta: { error, active, touched }, pad, ...custom
}) =>
  (<TextField
    {...input}
    {...custom}
    style={{ ...customStyle, ...styles.inputCon }}
    errorText={touched && error && (active ? error : ' ')}
    errorStyle={{ minWidth: 100 }}
    inputStyle={styles.input}
    underlineDisabledStyle={styles.inputDisabled}
    floatingLabelText={label}
    floatingLabelStyle={{ top: '24px' }}
    onBlur={(e) => {
        input.onBlur(e);
        if (pad && input.value) {
          input.onChange(leftPad(input.value, pad, '0'));
        }
      }}
  />);

TField.propTypes = {
  customStyle: PropTypes.object,
  input: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.node,
  pad: PropTypes.number,
};

export default TField;



// WEBPACK FOOTER //
// ./src/containers/pay/TField.js